<template>
  <div id="userManagement">
    <h1>User Management</h1>
    <Calendar is-expanded :attributes="attributes" />
    <a
      v-b-modal.modal-center
      style="background-color: lightsalmon; margin: 5px; padding: 5px"
      >Add</a
    >
    <b-modal
      ref="myModal"
      id="modal-center"
      centered
      hide-footer
      title="Details"
    >
      Description:
      <input placeholder="Description" required v-model="calendarDescription" />
      <br />
      Specialist's Name:
      <input
        placeholder="specialistName"
        required
        v-model="calendarSpecialistName"
      />
      <br />
      Start date:
      <VueDatePicker v-model="calendarStartDate" />
      <br />
      End date:
      <VueDatePicker v-model="calendarEndDate" />
      <br />
      Start Time:
      <vue-timepicker
        v-model="calendarTimeStart"
        format="hh:mm a"
        close-on-complete
        manual-input
      />
      <br />
      End Time:
      <vue-timepicker
        v-model="calendarTimeEnd"
        format="hh:mm a"
        close-on-complete
        manual-input
      />
      <br />
      Color:
      <input placeholder="blue, red, etc." required v-model="calendarColor" />
      <br />
      <button
        @click="addCustomeCalendarEvent"
        style="font-family: 'Manrope', sans-serif"
      >
        submit
      </button>
    </b-modal>

    <a
      v-b-modal.modal-center2
      style="background-color: lightblue; margin: 5px; padding: 5px"
      >Edit/Remove</a
    >
    <b-modal
      ref="myModal2"
      id="modal-center2"
      centered
      hide-footer
      title="Details"
    >
      <div>
        <div v-for="(item, index) in todos" :key="item.id">
          <!-- Display-->
          <div v-if="!item.editing">
            Description:
            {{ item.description }}
            <br />
            Specialist's Name:
            {{ item.specialistName }}
            <br />
            Date:
            {{ item.startDate }} to {{ item.endDate }}
            <br />
            Time:
            {{ item.startTime }} to {{ item.endTime }}
            Color:
            {{ item.color }}
            <br />
            <button @click="editItem(index)">Edit</button>
            <button @click="removeItem(index)">Remove</button>
          </div>

          <!-- Edit mode -->
          <div v-else>
            Description:
            <input v-model="item.description" />
            <br />
            Specialist's Name:
            <input v-model="item.specialistName" />
            <br />
            Start date:
            <VueDatePicker v-model="item.startDate" />
            <br />
            End date:
            <VueDatePicker v-model="item.endDate" />
            <br />
            Start Time:
            <vue-timepicker
              v-model="item.startTime"
              format="hh:mm a"
              close-on-complete
              manual-input
            />
            <br />
            End Time:
            <vue-timepicker
              v-model="item.endTime"
              format="hh:mm a"
              close-on-complete
              manual-input
            />
            <br />
            Color:
            <input v-model="item.color" />
            <button @click="saveItem(index)">Save</button>
            <button @click="cancelEdit(index)">Cancel</button>
          </div>
          <br />
          <br />
        </div>
      </div>
    </b-modal>
    <br />
    <br />
    <br />
    <br />
    <table>
      <thead>
        <tr style="background-color: orange">
          <th>Name</th>
          <th>Email</th>
          <th>Address</th>
          <th>Job</th>
          <th>Active</th>
          <th>Suspend</th>
          <th>Activate</th>
          <th>Manage Role</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.Firstname }} {{ user.Lastname }}</td>
          <td>{{ user.Email }}</td>
          <td>
            {{ user.Country }} {{ user.State }} {{ user.City }}
            {{ user.Zipcode }}
          </td>
          <td>
            {{ user.Jobfunction }} {{ user.Joblevel }} {{ user.Jobtitle }}
          </td>
          <td>{{ user.Approved }}</td>
          <td>
            <button class="btn btn-danger" @click="suspendUser(user.Email)">
              Suspend
            </button>
          </td>
          <td>
            <button class="btn btn-primary" @click="activateUser(user.Email)">
              Activate
            </button>
          </td>
          <td>
            <button
              class="btn btn-info"
              @click="updateRole(user.Email, user.Rolemanage)"
            >
              {{ user.Rolemanage }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <h3>Field Trial waivers</h3>
    <div id="fieldtrial-waiver"></div>
    <br />
    <h3>Volunteer waivers</h3>
    <div id="volunteer-waiver"></div>
  </div>
</template>

<script>
import axios from "../axios";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
// https://v2.vcalendar.io/
// import Calendar from 'v-calendar/lib/components/calendar.umd';
import { Calendar } from "v-calendar";

import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  data: function () {
    const todos = [];
    return {
      users: [],
      listWaiverFieldTrial: [],
      incId: todos.length,
      todos,
      calendarDescription: "",
      calendarSpecialistName: "",
      calendarStartDate: null,
      calendarEndDate: null,
      calendarTimeStart: "",
      calendarTimeEnd: "",
      calendarColor: "",
    };
  },
  mounted() {
    this.getUsers();
    this.getWaiverFieldTrial();
    this.getWaiverVolunteer();
    this.getCalendar();
  },
  components: {
    Calendar,
    VueDatePicker,
    VueTimepicker,
    // DatePicker
  },
  computed: {
    attributes() {
      return [
        ...this.todos.map((todo) => ({
          dates: { start: todo.startDate, end: todo.endDate },
          bar: {
            color: todo.color,
          },
          popover: {
            label:
              todo.description +
              " from " +
              todo.startTime +
              " to " +
              todo.endTime +
              ". Specialist's Name: " +
              todo.specialistName,
            visibility: "focus",
          },
          customData: todo,
        })),
      ];
    },
  },
  methods: {
    editItem(index) {
      this.$set(this.todos[index], "editing", true);
    },
    saveItem(index) {
      this.$set(this.todos[index], "editing", false);
      this.updateCalendar();
    },
    cancelEdit(index) {
      this.$set(this.todos[index], "editing", false);
    },
    removeItem(index) {
      this.todos.splice(index, 1);
      this.updateCalendar();
    },
    addCustomeCalendarEvent() {
      this.todos.push({
        description: this.calendarDescription,
        specialistName: this.calendarSpecialistName,
        startDate: this.calendarStartDate,
        endDate: this.calendarEndDate,
        startTime: this.calendarTimeStart,
        endTime: this.calendarTimeEnd,
        color: this.calendarColor,
      });
      this.updateCalendar();
      this.$refs.myModal.hide();
      this.calendarDescription = "";
      this.calendarSpecialistName = "";
      this.calendarColor = "";
      this.calendarStartDate = null;
      this.calendarEndDate = null;
      this.calendarTimeStart = "";
      this.calendarTimeEnd = "";
    },
    updateCalendar() {
      const result = JSON.stringify(this.todos);
      axios
        .post("api/updateAdminCalendar", { calendar: result })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCalendar() {
      axios
        .get("api/getAdminCalendar")
        .then((response) => {
          console.log(response);
          const parsed = JSON.parse(response.data.Calendar);
          this.todos = parsed.map((item, index) => ({
            ...item,
            id: item.id || Date.now() + index,
            editing: false,
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUsers() {
      axios
        .get("api/getUsers")
        .then((response) => {
          //   console.log(response);
          this.setupUsers(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setupUsers(res) {
      //   var key = 0;
      this.users = [];
      res.data.forEach((item) => {
        this.users.push(item);
      });
      // console.log(
      //   this.users.map((user, index) => ({ ...user, id: index + 1 }))
      // );
    },
    suspendUser(email) {
      if (confirm("Are you sure you want to suspend this user?")) {
        axios
          .post("api/suspendUsers", { email: email })
          .then(() => {
            // console.log(response);
            this.getUsers();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    activateUser(email) {
      if (confirm("Are you sure you want to activate this user?")) {
        axios
          .post("api/activateUsers", { email: email })
          .then(() => {
            // console.log(response);
            this.getUsers();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    updateRole(email, cur) {
      var toRole = "Registered User";
      if (cur == "Registered User") {
        toRole = "Admin";
      }
      if (
        confirm(
          "Are you sure you want to change role of this user to " + toRole + "?"
        )
      ) {
        axios
          .post("api/updateRole", { email: email, role: toRole })
          .then(() => {
            // console.log(response);
            this.getUsers();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getWaiverFieldTrial() {
      axios
        .get("api/getWaiverFieldTrial")
        .then((response) => {
          console.log(response);
          const files = response.data;
          const container = document.getElementById("fieldtrial-waiver");
          files.forEach((file) => {
            const { fileName, content } = file;
            const nameWithoutExtension = fileName.replace(/\.[^/.]+$/, "");
            this.listWaiverFieldTrial.push(nameWithoutExtension);

            const byteCharacters = atob(content);
            const byteNumbers = new Array(byteCharacters.length)
              .fill()
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            const item = document.createElement("div");
            item.innerHTML = `
            <br>
                <span>${fileName}</span>
                <a href="${url}" target="_blank">View</a>
                |
                <a href="${url}" download="${fileName}">Download</a>
                <span id="${nameWithoutExtension}"></span>
                <br>
            `;
            container.appendChild(item);
          });
          this.getFieldTrialUsers();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getFieldTrialUsers() {
      const li = this.listWaiverFieldTrial;
      axios
        .post("api/getFieldTrialUsers", { list: li })
        .then((response) => {
          const infos = response.data;
          console.log(infos);
          infos.forEach((info) => {
            const container = document.getElementById(info.Fileid);
            const item = document.createElement("div");
            const areaFocusList = JSON.parse(info.Anw1);
            item.innerHTML = `
                Email: ${info.Email}<br>
                Name: ${info.FirstName} ${info.LastName}<br>
                Onsite Date(s): ${info.Date.split(",")}<br>
                Child's Birth Date: ${info.Birth}<br>
                Area Focus: <br>${areaFocusList.join("<br>")}<br>
            `;
            container.appendChild(item);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getWaiverVolunteer() {
      axios
        .get("api/getWaiverVolunteer")
        .then((response) => {
          const files = response.data;
          const container = document.getElementById("volunteer-waiver");
          files.forEach((file) => {
            const { fileName, content } = file;
            const byteCharacters = atob(content);
            const byteNumbers = new Array(byteCharacters.length)
              .fill()
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            const item = document.createElement("div");
            item.innerHTML = `
                <span>${fileName}</span>
                <br>
                <a href="${url}" target="_blank">View</a>
                |
                <a href="${url}" download="${fileName}">Download</a>
            `;
            container.appendChild(item);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
td,
th {
  border: 1px solid black;
}
</style>
